import {
    Grid,
    ButtonGroup,
    makeStyles,
    Button,
    Typography,
    CardMedia
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import HomeIcon from '@material-ui/icons/Home';

import noveMlynyImg from '../../Images/Nove_Mlyny.jpg'

const useStyles = makeStyles(()=>({
    appendMenu: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '110%',
        background: 'linear-gradient(0deg, rgb(202 208 196) 35%, rgb(47 181 213) 100%)',
        zIndex: 100
    },
    buttonGroup: {
        margin: '60px 0px'
    },
    closeButton: {
        alignSelf: 'flex-start',
        color: 'white',
    },
    menuButton: {
        color: 'white',
        width: '90vw',
        height: '70px',
        backgroundColor: '#6dc0ce'
    },
    title: {
      fontFamily: 'Petit Formal Script',
      color: 'white',
      padding: '10px',
      textAlign: 'center',
      fontSize: '35px',
    },
    cardMedia: {
        width: '100%',
        height: '200px',
        marginTop: '-150px',
        position: 'absolute',
        bottom: 0,
        zIndex: -1,
    }
}))

export default function BurgerMenu( { handleAppend } ) {
    const classes = useStyles();

    return(
        <Grid container alignContent='center' direction='column' className={classes.appendMenu}>
            <Button onClick={() => handleAppend()} className={classes.closeButton} >
                <CloseIcon fontSize='large' />
            </Button>
            <ButtonGroup className={classes.buttonGroup} orientation='vertical' variant="text" size='large'>
                  <Button href='/' ><HomeIcon fontSize='large' style={{ color: 'white' }} /></Button>
                  <Button href='/pricelist' className={classes.menuButton}>Ceník</Button>
                  <Button href='/calendar' className={classes.menuButton}>Termíny</Button>
                  <Button href='/photogallery' className={classes.menuButton}>Fotogalerie</Button>
                  <Button href='/contact' className={classes.menuButton}>Kontakt</Button>
            </ButtonGroup>
            <Typography className={classes.title} >
                Dolní Věstonice
            </Typography>
            <CardMedia image={noveMlynyImg} title='' className={classes.cardMedia} />
        </Grid>
    )
}